// Guarantees the EUR/RON exchange rate is available to any operation editor
// (devis / facture / réception / achat / transport …) for the live €<->RON
// unit-price conversion in `EditCurrency`.
//
// Historically the rate lived in `localStorage.rate_eur_ron`, written ONLY as a
// side-effect of `updateCurrency()` on the dashboards / notification dropdown.
// If a user opened an operation edit without first visiting one of those pages,
// the key was missing (or "NaN") and the RON field computed to empty/NaN.
//
// This mixin loads the rate itself on `created()`, from the SAME live ECB source
// the Comptabilité page uses (`GET /api/currency/ecb`), falling back to the legacy
// manually-entered DB value (`GET /api/currency`) if the ECB feed is unreachable.
// It keeps writing into `localStorage.rate_eur_ron` so the existing synchronous
// read-sites need no change — they simply get a reliably-populated, ECB-based value.
import axios from '@/axios.js'

export default {
  methods: {
    async ensureEurRonRate () {
      // 1) live ECB rate (same source as Finance / Accounting)
      try {
        const r = parseFloat((await axios.get('/currency/ecb')).data.eur_ron)
        if (r && !isNaN(r)) {
          localStorage.setItem('rate_eur_ron', r.toFixed(4))
          return r
        }
      } catch (e) { /* fall through to the manual DB value */ }
      // 2) fallback: manually-entered DB rate (legacy /currency)
      try {
        const r = parseFloat((await axios.get('/currency')).data.eur_ron)
        if (r && !isNaN(r)) {
          localStorage.setItem('rate_eur_ron', r.toFixed(4))
          return r
        }
      } catch (e) { /* keep whatever was already in localStorage */ }
      return null
    }
  },
  created () {
    this.ensureEurRonRate()
  }
}
